// extracted by mini-css-extract-plugin
export var avatarContainer = "_cx-0";
export var avatarTypingWave = "_cx-i";
export var gray = "_cx-f";
export var green = "_cx-c";
export var icon = "_cx-9";
export var image = "_cx-1";
export var lg = "_cx-6";
export var md = "_cx-5";
export var presenceDot = "_cx-b";
export var red = "_cx-d";
export var sm = "_cx-4";
export var status = "_cx-a";
export var typingDot = "_cx-h";
export var typingPill = "_cx-g";
export var xl = "_cx-7";
export var xs = "_cx-3";
export var xxl = "_cx-8";
export var xxs = "_cx-2";
export var yellow = "_cx-e";